import { Component, Input, ViewChild } from '@angular/core';
import { venda, bonificacao, amostra } from '../../../../configuracoes/app/pedido/tipo-venda';
import { PedidoFilter } from '../../../../pedido/filter/pedido-filter';
import { PedidoPedidoListComponent } from '../../../../pedido/pedido/list/pedido-pedido-list.component';
import { pedidoStatusMetas, pedidoNaoLiberado } from '../../../../pedido/status';
import { CampanhaFilter } from '../../filter';
import { referenciaDataEmissao } from '../../../../pedido/referencia-data';

@Component({
    selector: 'sgt-campanha-pedido-view',
    templateUrl: './campanha-pedido-view.component.html',
    styleUrls: ['./campanha-pedido-view.component.less']
})
export class CampanhaPedidoViewComponent {
    @Input() idCampanha: number;
    @Input() filter: CampanhaFilter;
    @Input() objetivoVenda = false;
    @Input() objetivoBonificacao = false;
    /** Se deve exibir os pedidos em statuses considerados nos realizados das metas */
    @Input() showStatusMetas = true;
    /** Se deve exibir os pedidos comm status não liberado */
    @Input() showStatusNaoLiberado = false;

    pedidoFilter = new PedidoFilter();
    @ViewChild('list') list: PedidoPedidoListComponent;

    /** Seta o filtro dos pedido */
    private setPedidoFilter() {
        this.pedidoFilter = new PedidoFilter(referenciaDataEmissao);

        // Campanha
        if (this.idCampanha > 0) {
            this.pedidoFilter.idsCampanhas = [this.idCampanha];
        } else if (this.idCampanha === -1) { // Sem Campanha
            this.pedidoFilter.idsCampanhas = null;
            this.pedidoFilter.campanhaNull = true;
        }

        // Periodividade da vigência da campanha
        this.pedidoFilter.periodicidadeVigencia = this.filter.periodicidadeVigencia;
        this.pedidoFilter.dataInicioVigencia = this.filter.dataInicioVigencia;
        this.pedidoFilter.dataTerminoVigencia = this.filter.dataTerminoVigencia;
        this.pedidoFilter.dataInicioVigenciaPeriodo = this.filter.dataInicioVigenciaPeriodo;
        this.pedidoFilter.dataTerminoVigenciaPeriodo = this.filter.dataTerminoVigenciaPeriodo;
        this.pedidoFilter.mesVigencia = this.filter.mesVigencia;
        this.pedidoFilter.trimestreVigencia = this.filter.trimestreVigencia;
        this.pedidoFilter.semestreVigencia = this.filter.semestreVigencia;
        this.pedidoFilter.anoVigencia = this.filter.anoVigencia;

        // Status
        this.pedidoFilter.status = [];
        // Metas
        if (this.showStatusMetas) {
            pedidoStatusMetas.forEach(status => this.pedidoFilter.status.push(status.id));
        }
        // Não Liberados
        if (this.showStatusNaoLiberado) {
            this.pedidoFilter.status.push(pedidoNaoLiberado.id);
        }

        // Tipos
        this.pedidoFilter.tiposVendas = [];
        // Venda
        if (this.objetivoVenda) {
            this.pedidoFilter.tiposVendas.push(venda.id);
        }
        // Bonificação/Amostra
        if (this.objetivoBonificacao) {
            this.pedidoFilter.tiposVendas.push(bonificacao.id);
            this.pedidoFilter.tiposVendas.push(amostra.id);
        }

        // Representantes
        this.pedidoFilter.idsRepresentantes = this.filter.idsRepresentantes;

        // Pessoas (Cliente promoção)
        this.pedidoFilter.idPessoaCampanha = this.filter.idPessoa;
    }

    /** Pesquisa os pedidos */
    search() {
        if (!this.idCampanha) {
            return
        }
        this.setPedidoFilter();
        setTimeout(() => this.list?.search(), 0);
    }
}
